import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <h3>{I18n.t("papp.products.EditProductView.StepPayments.hint.p1")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepPayments.hint.p2")}</p>

    <p>{I18n.t("papp.products.EditProductView.StepPayments.hint.p3")}</p>

    <p>{I18n.t("papp.products.EditProductView.StepPayments.hint.p4")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPayments/StepPaymentsHint.jsx